import { Form, Image, Input } from "antd";
import { doc, setDoc } from "firebase/firestore";
import { nanoid } from "nanoid";
import { db } from "../firebase";
import { ReactNode, useState } from "react";
import { useNavigate } from "react-router-dom";
import { HomeOutlined, MailOutlined } from "@ant-design/icons";
import logo from "./../Images/SWSNoBG.png";
import TextArea from "antd/es/input/TextArea";
export const Contact = () => {
  const [contactForm] = Form.useForm();
  const [isVis, setIsVis] = useState<null | string>(null);
  const nav = useNavigate();

  const handleContact = () => {
    contactForm.validateFields().then((values) => {
      const newId = nanoid();
      setDoc(doc(db, `contact/${newId}`), {
        id: newId,
        ...values,
        date: new Date().getTime(),
        complete: false,
      })
        .then(() => {
          setIsVis("Thanks, we will get in touch when we can.");
          setTimeout(() => {
            setIsVis(null);
          }, 30000);
          contactForm.resetFields();
        })
        .catch((err) => console.error(err));
    });
  };

  const Section = ({
    eyebrow,
    title,
    children,
  }: {
    eyebrow: string;
    title: string;
    children: ReactNode;
  }) => (
    <section className="w-full border border-[#9A6D26]/20 bg-black/10">
      <div className="border-b border-white/10 px-5 py-4 md:px-8">
        <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#5C6B73]">
          {`// ${eyebrow}`}
        </p>
        <h2 className="mt-2 font-oswald text-2xl uppercase tracking-tight text-white">
          {title}
        </h2>
        <div className="mt-3 h-1 w-12 bg-[#F6B34B]" />
      </div>
      <div className="p-5 md:p-8">{children}</div>
    </section>
  );

  const inputClass =
    "!border-white/10 !bg-white/[0.03] !text-white placeholder:!text-[#5C6B73] hover:!border-[#F6B34B]/70 focus:!border-[#F6B34B]";

  return (
    <div className="relative min-h-screen w-full overflow-hidden bg-[#1f1e23] text-white selection:bg-[#F6B34B] selection:text-[#1D1928]">
      <div className="absolute inset-0 pointer-events-none bg-[radial-gradient(circle_at_top,_rgba(246,179,75,0.10),_transparent_35%),radial-gradient(circle_at_bottom_right,_rgba(92,107,115,0.12),_transparent_35%),linear-gradient(to_bottom,_rgba(0,0,0,0.15),_transparent)]" />
      <div className="absolute inset-0 bg-gradient-to-b from-[#1f1e23]/70 via-[#1f1e23]/95 to-[#1f1e23]" />

      <main className="relative z-10 mx-auto flex min-h-screen w-full max-w-7xl flex-col gap-8 px-6 py-10 md:py-16">
        <header className="border border-white/10 bg-[#1D1928]/50 p-6 backdrop-blur-sm md:p-10">
          <div className="flex flex-col gap-8 md:flex-row md:items-end md:justify-between">
            <div>
              <p className="font-mono text-xs uppercase tracking-[0.3em] text-[#5C6B73] animate-pulse">
                {"// SYSTEM.CONTACT :: TRANSMISSION_READY"}
              </p>
              <h1 className="mt-5 font-oswald text-5xl uppercase leading-none tracking-tighter text-[#F6B34B] md:text-7xl">
                Contact
              </h1>
              <p className="mt-5 max-w-xl border-l-2 border-[#F6B34B] pl-4 font-mono text-sm leading-relaxed text-gray-300 md:text-base">
                Start a project, ask a question, or send us the brief.
                <span className="mt-2 block text-[#5C6B73]">
                  ScryptWorx Studios // NZ based digital builds
                </span>
              </p>
            </div>

            <div className="flex flex-wrap items-center gap-3">
              <Image
                src={logo}
                alt="SCRYPTWORX STUDIOS"
                className="max-w-[180px] opacity-90 md:max-w-[240px]"
                preview={false}
              />
              <button
                className="border border-[#5C6B73] px-5 py-3 font-mono text-xs uppercase tracking-widest text-[#5C6B73] transition-all hover:border-[#F6B34B] hover:text-[#F6B34B]"
                onClick={() => nav("/")}
                type="button"
              >
                Home
              </button>
            </div>
          </div>
        </header>

        <Section eyebrow="message.compose" title="Contact Us">
          {isVis ? (
            <div className="border border-[#F6B34B]/40 bg-black/20 p-6">
              <p className="font-mono text-sm uppercase tracking-widest text-[#F6B34B]">
                {isVis}
              </p>
              <button
                className="mt-6 border border-[#5C6B73] px-5 py-3 font-mono text-xs uppercase tracking-widest text-[#5C6B73] transition-all hover:border-[#F6B34B] hover:text-[#F6B34B]"
                onClick={() => nav("/")}
                type="button"
              >
                Return Home
              </button>
            </div>
          ) : (
            <div className="grid grid-cols-1 gap-6 lg:grid-cols-[1fr_0.75fr]">
              <div className="border border-white/10 bg-white/[0.02] p-5 md:p-6">
                <Form form={contactForm} layout="vertical" className="contact-form">
                  <Form.Item
                    label={<span className="font-mono text-xs uppercase tracking-widest text-[#5C6B73]">Name</span>}
                    name="name"
                    rules={[{ required: true, message: "Your name is required" }]}
                  >
                    <Input className={inputClass} placeholder="Your name" />
                  </Form.Item>
                  <Form.Item
                    label={<span className="font-mono text-xs uppercase tracking-widest text-[#5C6B73]">Phone</span>}
                    name="phone"
                    rules={[
                      {
                        required: true,
                        message: "Your contact phone number is required",
                      },
                    ]}
                  >
                    <Input
                      className={inputClass}
                      id="phone"
                      placeholder="Your phone number"
                    />
                  </Form.Item>
                  <Form.Item
                    label={<span className="font-mono text-xs uppercase tracking-widest text-[#5C6B73]">Email</span>}
                    name="email"
                    rules={[
                      {
                        required: true,
                        message: "Your contact email is required",
                      },
                      {
                        type: "email",
                        message: "This must be a valid email address",
                      },
                    ]}
                  >
                    <Input
                      className={inputClass}
                      id="email"
                      placeholder="Your email"
                    />
                  </Form.Item>
                  <Form.Item
                    label={<span className="font-mono text-xs uppercase tracking-widest text-[#5C6B73]">Message</span>}
                    name="message"
                    rules={[{ required: true, message: "A message is required" }]}
                  >
                    <TextArea
                      className={inputClass}
                      placeholder="Your message..."
                      rows={5}
                    />
                  </Form.Item>
                </Form>

                <div className="flex flex-wrap gap-3">
                  <button
                    className="border border-[#F6B34B]/70 bg-[#F6B34B]/10 px-5 py-3 font-mono text-xs uppercase tracking-widest text-[#F6B34B] transition-all hover:bg-[#F6B34B] hover:text-[#1D1928]"
                    onClick={handleContact}
                    type="button"
                  >
                    Submit Transmission
                  </button>
                  <button
                    className="border border-[#5C6B73] px-5 py-3 font-mono text-xs uppercase tracking-widest text-[#5C6B73] transition-all hover:border-[#F6B34B] hover:text-[#F6B34B]"
                    onClick={() => nav("/")}
                    type="button"
                  >
                    <HomeOutlined /> Home
                  </button>
                </div>
              </div>

              <aside className="border border-white/10 bg-white/[0.02] p-5 md:p-6">
                <div className="mb-8 flex items-center justify-between text-[#F6B34B]">
                  <span className="text-xl">
                    <MailOutlined />
                  </span>
                  <span className="font-mono text-[9px] uppercase tracking-[0.25em] text-[#5C6B73]">
                    [ Open Channel ]
                  </span>
                </div>
                <h3 className="font-oswald text-xl uppercase tracking-tight text-white">
                  Project Intake
                </h3>
                <p className="mt-4 font-mono text-sm leading-relaxed text-gray-300">
                  Tell us what you are building, where it needs to live, and how
                  fast you need it moving. We will respond as soon as we can.
                </p>
                <p className="mt-6 font-mono text-[10px] uppercase tracking-[0.25em] text-[#5C6B73]">
                  Response queued // SWS contact registry
                </p>
              </aside>
            </div>
          )}
        </Section>
      </main>
    </div>
  );
};
